/**
 * @description Returns true if the given dates are on the same day, month and year.
 * Returns false otherwise.
 *
 * @param {Date} firstDate The first date to check.
 * @param {Date} secondDate The second date to check.
 *
 * @returns {boolean} If the dates are the same.
 */
export var isSameDay = function (firstDate, secondDate) { return (firstDate.getFullYear() === secondDate.getFullYear() &&
    firstDate.getMonth() === secondDate.getMonth() &&
    firstDate.getDate() === secondDate.getDate()); };
//# sourceMappingURL=isSameDay.js.map